import { render, staticRenderFns } from "./BottomAdForm.vue?vue&type=template&id=1fa54339&"
import script from "./BottomAdForm.vue?vue&type=script&lang=js&"
export * from "./BottomAdForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports